<template>
  <section>
    <!--工具条-->
    <div>
      <el-col :span="2">
        <el-input v-model="filters.matName" placeholder="物资名称"></el-input>
      </el-col>
      <el-col :span="2">
        <el-input
          v-model="filters.saleUnitsName"
          placeholder="销售单位"
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-input
          v-model="filters.consigneeName"
          placeholder="收货单位"
        ></el-input>
      </el-col>
      <el-col :span="8">
        <el-date-picker
          type="datetime"
          placeholder="开始日期"
          v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-date-picker
          type="datetime"
          placeholder="结束日期"
          v-model="filters.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getReportList(1)">查询</el-button>
        <el-button type="primary" @click="downReport">导出</el-button>
      </el-col>
    </div>
    <!--列表-->
    <el-table
      :data="dmList"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column prop="SaleUnitsName" label="销售单位"></el-table-column>
      <el-table-column prop="ConsigneeName" label="收货单位"></el-table-column>
      <el-table-column prop="MatName" label="物资名称"></el-table-column>
      <el-table-column prop="GrossWeight" label="毛重"></el-table-column>
      <el-table-column prop="TareWeight" label="皮重"></el-table-column>
      <el-table-column prop="NetWeight" label="净重"></el-table-column>
      <el-table-column prop="PrintCount" label="累计车数"></el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="filters.intPageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import { BaseApiUrl } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Axios from "axios";
import printJS from "print-js";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        matName: "",
        startTime: "",
        endTime: "",
        saleUnitsName: "",
        consigneeName: "",
        page: 1,
        intPageSize: 20,
      },
      total: 0,
      dmList: [],
      sumData: {},
      listLoading: false,
    };
  },
  computed: {},
  methods: {
    getSummaries(param) {
      var sums = [];
      sums[0] = "合计";
      sums[1] = "";
      sums[2] = "";
      sums[3] = this.sumData.GrossWeight;
      sums[4] = this.sumData.TareWeight;
      sums[5] = this.sumData.NetWeight;
      sums[6] = this.sumData.PrintCount;
      return sums;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getReportList();
    },
    //获取原材料消耗
    getReportList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      api
        .GetWeighingInSaleOutGroup(para)
        .then((res) => {
          if (res && res.data && res.data.response && res.data.response.data)
            this.dmList = res.data.response.data;
          this.sumData = res.data.responsesum;
          this.total = res.data.response.dataCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //导出原材料消耗
    downReport() {
      let para = this.filters;
      var sheetName = "销售过磅统计报表";
      api.DownWeighingInSaleOutGroup(para, sheetName).then((res) => {});
    },
  },
  mounted() {
    this.getReportList();
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
